import { SignedStatus } from './signedStatus';

export interface OfferingTransactionDocumentAudit {
  id: number;
  offeringTransactionId: number;
  offeringTransactionDocumentId: number;
  user: DocumentAuditUser;
  action: DocumentAuditAction;
  status: SignedStatus;
  createdAtIp: string;
  createdAt: Date;
  active: boolean;
}

export interface DocumentAuditUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  profilePictureUrl?: string;
}

export enum DocumentAuditAction {
  VIEW = 'VIEW',
  SIGN = 'SIGN',
  CANCEL = 'CANCEL',
}
